import * as PIXI from 'pixi.js';
import gameState from "slotworks/model/game-state";
import RainbowStacksFreespinRecord from "integration/revolver/schema/freespin-record";
import Layers from "slotworks/graphics/layers/layers";
import particleManager from "slotworks/graphics/particles/particle-manager";
import Point from "slotworks/utils/geom/point";

export function GetLastFreespinRecord() {
    const records = gameState.getCurrentGame().records;
    for(let i = records.length - 1; i >= 0; i--) {
        const record = records[i];
        if(record instanceof RainbowStacksFreespinRecord) {
            return record;
        }
    }
    return null;
}

export function AddParticle(id: string, layer: Layers) {
    const container = new PIXI.Container();
    const particle = particleManager.add(id, new Point(0, 0), container);

    layer.addParticle(id, particle);
    layer.container.addChild(container);

    return layer.getParticle(id);
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/util/tools.ts